import { getGelTokens } from "@tal-gel/theming";
import styled from "@emotion/styled";

const tokens = getGelTokens();

const FilterBar = styled.div({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px 16px",
  [`@media (max-width: ${tokens.global.breakpointSmall}px)`]: {
    flexDirection: "column",
    alignItems: "stretch",
  },
});

const FilterChips = styled.div({
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  flex: "1 1 auto",
});

const FilterActions = styled.div({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  whiteSpace: "nowrap",

  // Mobile: sit under the chips, full width
  [`@media (max-width: ${tokens.global.breakpointSmall}px)`]: {
    width: "100%",
    justifyContent: "space-between",
  },
});

export { FilterBar, FilterChips, FilterActions };
